/**
 * Reviews  Functional Component
 * @Package - seo/brand
 * @Author - Cybage@UPWA-Team
 * @description: Common SEO Reviews
 */

/**
 *  SEO's Reviews Component
 */
import React, { useState, useMemo } from 'react'
import { Title } from '@usap/widgets'
import { Box, Button, IcoMoon } from '@usap/uicomponents'
import SingleReview from '../seoComponents/SeoReviews/SingleReview'

export default function SeoReviews({
  id,
  data,
  headings,
}) {
  const title = headings.reviews || 'Customer Reviews'

  const [showAll, setShowAll] = useState(false)

  const reviewData = data && !showAll ? data.slice(0, 3) : data

  const toggleButtonInfo = showAll ? 'Show Less' : 'Show More'

  const styleMemo = useMemo(
    () => ({
      box1Marg: { horizontal: 'auto', top: '0px', bottom: 'small' },
      box1Pad: { horizontal: 'medium', vertical: 'small' },
    }),
    [],
  )

  if (typeof data === 'object' && data.length === 0) {
    return null
  }
  return (
    <Box
      id={id}
      width="1248px"
      margin={styleMemo.box1Marg}
      pad={styleMemo.box1Pad}
    >
      <Box margin={{ vertical: 'small' }}>
        <Title type="h2" size="20px" label={title} />
      </Box>

      <Box>
        {reviewData.map((singleReview, index) => {
          const { link } = singleReview
          const mapKey = `${link}${index}`

          return <SingleReview key={mapKey} review={singleReview} />
        })}

        {data.length > 3 && (
          <Box
            id={`${toggleButtonInfo}MoreReviews`}
            align="center"
            pad={{ vertical: 'medium' }}
          >
            <Button
              id={`${toggleButtonInfo}MoreReviewsBtn`}
              custom
              hideBorder={false}
              label={toggleButtonInfo}
              onClick={() => {
                setShowAll(!showAll)
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}
